import ReactDOMServer from 'react-dom/server';
import Icon, { type IconNames } from '~/components/ui/Icon';

// hack to get the svg as string from the Icon component since @remixicon/react does not export the SVGs
export function setRemixiconAsCSSVar(varName: string, icon: IconNames) {
    const svgIcon = `data:image/svg+xml;utf8,${encodeURIComponent(
        ReactDOMServer.renderToStaticMarkup(<Icon icon={icon} />),
    )}`;
    document.body.style.setProperty(varName, `url("${svgIcon}")`);
}
